export default __webpack_public_path__ + "static/media/menu_logo.c8bab84f.png";